import Vue from 'vue'
import App from './App.vue'
import VueMeta from 'vue-meta'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import VueSSE from 'vue-sse'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'fork-awesome/css/fork-awesome.css'
import './styles/style.css'
import Vuelidate from 'vuelidate'
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMeta)
Vue.use(VueSSE)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

